import React from "react";

const DiscountCell = (params) => {
  return <>{Math.round(params.value)}</>;
};

export default DiscountCell; 
